
import React from "react";
import { Link } from "react-router-dom";

const SingleItem = ({
    data,
    index,
    paginateData,
    handleDelete,
}) => {
    const serialNumber =
        (Number(paginateData?.page || 1) - 1) *
        Number(paginateData?.limit || 10) +
        index +
        1;

    // Get all products from nested orders
    const products = (data?.orders || []).flatMap(
        (order) => order?.products || []
    );

    // Remove duplicate types: Normal, Combo
    const orderTypes = [
        ...new Set(
            (data?.orders || [])
                .map((order) => order?.type)
                .filter(Boolean)
        ),
    ];

    // Calculate totals from nested orders
    const totalProfitAmount = (data?.orders || []).reduce(
        (total, order) => total + Number(order?.profitAmount || 0),
        0
    );

    const totalWithProfit = (data?.orders || []).reduce(
        (total, order) => total + Number(order?.totalWithProfit || 0),
        0
    );

    const averageProfit = data?.orders?.length
        ? (
            data.orders.reduce(
                (total, order) => total + Number(order?.profit || 0),
                0
            ) / data.orders.length
        ).toFixed(2)
        : "0.00";



    return (
        <tr>
            <td data-label="S.N.">{serialNumber}</td>

            <td data-label="Type">
                {orderTypes.join(", ") || "—"}
            </td>

            <td data-label="Order #">
                {data?.orderNo ?? "—"}
            </td>

            <td data-label="Username">
                {data?.user?._id ? (
                    <Link to={`/admin/user/details/${data.user._id}`}>
                        <span className="fw-bold">
                            {data?.user?.username || "N/A"}
                        </span>
                    </Link>
                ) : (
                    data?.user?.username || "N/A"
                )}
            </td>

            <td data-label="Products">
                <div className="table-responsive">
                    <table className="table table-bordered table-sm mb-0">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th className="text-center">Quantity</th>
                                <th className="text-end">Price</th>
                            </tr>
                        </thead>

                        <tbody>
                            {products.length > 0 ? (
                                products.map((item, productIndex) => (
                                    <tr key={item?._id || productIndex}>
                                        <td>
                                            {item?.productInfo?.name ||
                                                item?.productId?.name ||
                                                "N/A"}
                                        </td>

                                        <td className="text-center">
                                            {item?.quantity ?? 0}
                                        </td>

                                        <td className="text-end">
                                            {Number(item?.price || 0).toFixed(2)}$
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={3}
                                        className="text-center text-muted"
                                    >
                                        No products found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </td>

            <td data-label="Amount">
                {Number(data?.totalSubtotal || 0).toFixed(2)}$
            </td>

            <td data-label="Profit %">
                {averageProfit}%
            </td>

            <td data-label="Profit Amount">
                {totalProfitAmount.toFixed(2)}$
            </td>

            <td data-label="Total With Profit">
                {totalWithProfit.toFixed(2)}$
            </td>

            <td data-label="Status">
                {data?.status ? (
                    <span className="badge badge--success text-success">
                        Paid
                    </span>
                ) : (
                    <span className="badge badge--warning text-warning">
                        Unpaid
                    </span>
                )}
            </td>

            <td data-label="Action">
                <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={()=>handleDelete(data?._id)}
                >
                    <i className="la la-trash" /> Delete
                </button>
            </td>
        </tr>
    );
};

export default SingleItem;
